<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="recordNav">
        <p>
          高水平职业球员认证详情
        </p>
        <div style="display: flex">
          <p
            class="audit"
            @click="verify"
            v-if="
              ['system', 'super'].includes(member_type) && recordInfo.certification_status === 'audit'
            "
          >
            审核
          </p>
          <p
            class="audit"
            v-if="
              ['student', 'expireStudent'].includes(member_type) && recordInfo.certification_status === 'perfect'
            "
            @click="perfectPlayer"
          >
            继续完善
          </p>
          
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="recordMain">
        <yioks-loading v-show="loading"></yioks-loading>
        <div v-if="!loading" class="Info">
          <vue-scroll :ops="ops" ref="vs">
            <div
              class="mainInfo"
              v-if="recordInfo.authentication_id"
            >
              <template >
                <div
                  class="title"
                  style="display: flex; justify-content: space-between"
                >
                  <div style="display: flex">
                    <v-icon
                      class="logo"
                      name="regular/clock"
                      scale="1.6"
                    ></v-icon>
                    <p class="titleInfo">审核过程</p>
                  </div>
                </div>
                <div class="timeline">
                  <div
                    class="timeline-item"
                    v-for="(audit, i) in auditData"
                    :key="audit.audit_id"
                  >
                    <div
                      class="item_tail"
                      v-show="i !== auditData.length - 1"
                    ></div>
                    <div
                      class="item_node"
                      v-if="audit.audit_type === 'audit'"
                    >
                      {{ audit.audit_status | AuthenticationStatus }}
                    </div>
                    <div class="item_node" v-else>提交</div>
                    <div class="item_wrap">
                      <div class="timestamp">
                        <span>{{ audit.create_time | time }}</span>
                        <!--                                               <span class="audit_people" v-if="audit.type ==='audit_score'">-->
                        <!--                            审核人：{{audit.unit_name | userRole}}（{{audit.user_name}}）-->
                        <!--                          </span>-->
                        <!--                                        <span class="audit_people" v-if="audit.audit_type==='submit_qua'">-->
                        <!--                              提交人：{{ audit.user_name }}-->
                        <!--                            </span>-->
                        <!--                                        <span class="audit_people" v-else>-->
                        <!--                                  审核人：{{ audit.user_name }}-->
                        <!--                              </span>-->
                      </div>
                      <div class="item_cont">
                        <p>
                          <span v-if="audit.audit_type === 'submit'">
                            高水平职业球员认证提交成功，正在审查
                          </span>
                          <span v-else> 审核 </span>
                          <span
                            v-if="
                              audit.audit_type !== 'submit' &&
                              audit.msg_info
                            "
                          >
                            ：{{ audit.msg_info }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template>
                <div class="title" style="justify-content: space-between">
                  <div style="display: flex">
                    <v-icon class="logo" name="user" scale="1.6"></v-icon>
                    <p class="titleInfo">
                      个人信息
                    </p>
                  </div>
                </div>
                <div class="perInfo">
                  <template>
                    <el-row class="score-row">
                      <el-col :span="12" class="score-col">
                        <p>姓名(中文)：{{ userMap.name }}</p>
                      </el-col>
                      <el-col :span="12" class="score-col">
                        <p>证件号：{{ userMap.id_number }}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="8" class="score-col">
                        <p>手机号：{{ userMap.mobile_phone || "--" }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>提交时间：{{ recordInfo.create_time | time }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>审核状态：{{ recordInfo.certification_status | AuthenticationStatus }}</p>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </template>
              <template>
                <div class="title">
                  <v-icon
                    class="logo"
                    name="regular/address-book"
                    scale="1.6"
                  ></v-icon>
                  <p class="titleInfo" style="color: red">高水平职业球员认证信息</p>
                </div>
                <div
                  class="recordInfo"
                >
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>认证类型：{{recordInfo.certification_type | AuthenticationType}}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>
                        证明材料：
                        <span v-if="recordInfo.ducoment_address" style="color: #4cd964"
                        ><a target="_blank" :href="recordInfo.ducoment_address"
                        >（点击查看证明材料）</a
                        >
                        </span>
                        <span v-else>暂未上传证明材料</span>
                      </p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>备注：{{ recordInfo.remark || "--" }}</p>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </div>
            <div v-else>
              <yioks-empty
                tips="数据不存在，请返回上一步重新查询。"
              ></yioks-empty>
            </div>
          </vue-scroll>
        </div>
        <template v-if="verifyFlag">
          <yioks-verify :flag="verifyFlag"
            :verifyBtn="true"
            :buttonText="'通过'"
            :is_show_btn_o="false"
            :is_info_request="true"
            :holderText="`如继续完善或审核拒绝，请输入理由`"
            @hideVerify="hideVerifyDialog"></yioks-verify>
        </template>
        <template v-if="add_show">
          <add-dialog :showAddDialog="add_show" :Info="{authentication_id:recordInfo.authentication_id}" @hideTips="hideAddDocumentTips"></add-dialog>
        </template>
      </div>
    </template>
  </tea-main>
</template>

<script>

import {
  high_player_certification_info,
  high_player_certification_audit,
} from "@/api/system_manager/api";

import {
  AuthenticationStatus,
  AuthenticationType,
  
} from "@/assets/js/yioksFilters";
import { storageData } from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/user";
import "vue-awesome/icons/regular/address-book";
import "vue-awesome/icons/tags.js";
import "vue-awesome/icons/regular/clock";

import fiveMixins from "@/minix/fiveMixins";

export default {
  name: "AuthenticationInfo",
  mixins: [fiveMixins],
  data() {
    return {
      ops: ops(),
      authentication_id:this.$route.query.authentication_id,
      recordInfo: {},
      userMap: {},
      auditData: [],
      verifyFlag:false,
      loading:false,
      add_show: false,
    };
  },
  computed: {
  
  },
  created() {
    
    const member_type = storageData.getUserInfo().member_type;
    const token = storageData.getToken();
    this.member_type = member_type;
    this.request();
    
  },
  methods: {
    
    request(flag) {
      this.loading = true;
      high_player_certification_info({
        authentication_id:this.authentication_id
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
            const {
              record,
              auditData,
              userMap,
            } = res.data.result;
            this.recordInfo = record;
            this.auditData = auditData;
            this.userMap = userMap;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    
    goBack() {
      this.$router.go(-1);
    },
    verify() {
      this.verifyFlag = true;
    },
    
    hideVerifyDialog(bool, params, msg) {
      if (bool) {
        high_player_certification_audit({
          authentication_id: this.recordInfo.authentication_id,
          status: params,
          msg_info: msg,
        })
          .then((res) => {
            if (Number(res.data.status) === 0) {
              switch (params) {
                case "Y":
                  this.recordInfo.certification_status = "pass";
                  break;
                case "N":
                  this.recordInfo.certification_status = "refused";
                  break;
                case "P":
                  this.recordInfo.certification_status = "perfect";
                  break;
              }
              this.verifyFlag = false;
              this.$message.success("审核成功");
              this.request(true);
              // this.$router.go(-1)
            } else {
              this.$message.error(res.data.msg);
              this.verifyFlag = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.verifyFlag = false;
          });
      } else {
        this.verifyFlag = false;
      }
    },
    perfectPlayer() {
      this.add_show = true
    },
    hideAddDocumentTips(bool,flag){
      this.add_show = bool;
      if (flag){
        this.$message.success('提交成功！')
        this.request();
      }
    },
  },
  filters: {
    AuthenticationStatus,
    AuthenticationType
  },

  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-verify": () => import("@/components/Tips/verify-adjust-applay"),
    "yioks-status": () => import("@/components/Tips/Status"),
    "yioks-dialog": () => import("@/components/Tips/Dialog"),
    "add-dialog": () => import('@/components/highPlayerAuthentication/AddDialog'),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.recordNav, .recordMain
  flex 1 1 auto
  height 100%
.recordNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .audit
    display flex
    justify-content center
    align-items center
    padding 5px 15px
    font-size 16px
    background-color $color_suc
    cursor pointer
.recordMain
  width 100%
  padding 25px 0 25px 0
  background-color $block_bg_color_base
  .Info
    padding 0 0 0 40px
    height 550px
    .mainInfo
      padding-right 40px
      padding-top 5px
      .zuxie-btn
        background none
        border 1px solid
        width 115px
        padding 10px 4px
        &:hover
          background $color_primary
      .perInfo, .recordInfo
        position relative
        margin-bottom 40px
        border 1px solid $color_white
        .score-row
          border-bottom 1px solid $color_white
          .score-table
            .row
              border-bottom 1px solid $color_white
              display flex
              &:last-child
                border-bottom none
              .score-col
               
                border-left 1px solid $color_white
                flex auto
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
          &:last-child
            border-bottom none
          .score-col
            
            border-left 1px solid $color_white
            &:first-child
              border-left none
            p
              margin 10px
              font-size $font_size_medium
              word-break break-all
              &.score-note
                text-align left
        .dashed-line
          width 100%
          position absolute
          bottom -22px
          left 0
          border 1px dashed $color_white
        &:last-child
          margin-bottom 0
      
      .title
        display flex
        margin-bottom 10px
        .titleInfo
          margin-left 10px
          font-size 18px
          line-height 1.6
      .timeline
        display block
        padding-left 3px
        .timeline-item
          position relative
          padding-bottom 20px
          .item_tail
            position absolute
            top 36px
            bottom 6px
            left 16px
            // height 100%
            border-left 2px solid #cccccc
          .item_node
            position absolute
            background-color #fff
            color #333
            border 1px solid #fff
            border-radius 50%
            // left -2px
            width 36px
            height @width
            font-size 12px
            display flex
            align-items center
            text-align center
            justify-content center
          .item_wrap
            position relative
            padding-left 50px
            top -3px
            .timestamp
              display flex
              // align-items center
              line-height 1
              margin-bottom 5px
              font-size 15px
              .audit_people
                flex 1
                text-align right
                margin-left 10px
            .item_cont
              display block
              background-color #fff
              color #333
              padding 10px
              border-radius 4px
              border 1px solid #cccccc
              overflow hidden
              font-size 15px
              box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
      
      .el-tag + .el-tag
        margin-left 10px
      .button-new-tag
        margin-left 10px
        height 32px
        line-height 30px
        padding-top 0
        padding-bottom 0
      .input-new-tag
        width 90px
        margin-left 10px
        vertical-align bottom
</style>
<style lang="stylus">
.tag_tag
  height auto
  white-space normal
</style>
